import React from 'react';
import { useFormContext } from 'react-hook-form';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import translate from '@/lib/intl/translate';

enum Selected {
  ALL = 'all',
  NONE = 'none',
  OTHER = 'other',
}

export default function SelectAllCheckboxesOrNone({
  fieldNames,
}: {
  fieldNames: string[];
}) {
  const { setValue, watch } = useFormContext();
  const [selected, setSelected] = React.useState(Selected.ALL);
  const values = watch(fieldNames);

  React.useEffect(() => {
    const entries = Object.entries(values);

    if (entries.every(([, value]) => value)) {
      setSelected(Selected.ALL);
    } else if (entries.some(([, value]) => value)) {
      setSelected(Selected.OTHER);
    } else if (selected !== Selected.NONE) {
      setSelected(Selected.NONE);
    }
  }, [selected, values]);

  const handleAllClick = React.useCallback(() => {
    fieldNames.forEach((name) => setValue(name, true));
  }, [fieldNames]);

  const handleNoneClick = React.useCallback(() => {
    fieldNames.forEach((name) => setValue(name, false));
  }, [fieldNames]);

  return (
    <div className="flex items-center justify-between gap-3 type-body1">
      {translate('SELECT')}:
      <Button
        className="min-w-0 p-0 font-regular"
        data-testid="constituent-export-csv-dialog-select-all"
        disabled={selected === Selected.ALL}
        onClick={handleAllClick}
        variant="text"
      >
        {translate('ALL')}
      </Button>
      <Divider className="h-3 border-grey-600" orientation="vertical" />
      <Button
        className="min-w-0 p-0 font-regular"
        data-testid="constituent-export-csv-dialog-select-none"
        disabled={selected === Selected.NONE}
        onClick={handleNoneClick}
        variant="text"
      >
        {translate('NONE')}
      </Button>
    </div>
  );
}
